import { useEffect, useState } from 'react';
var readOnLine = function () { return (typeof navigator === 'undefined' ? true : navigator.onLine); };
/**
 * CZNA-1624 — whether the browser currently has a network connection.
 *
 * Until this hook the module did not react to an outage at all: a cataloguer found out only
 * when saving failed, after the work was already typed in (UC ER-01). The browser exposes the
 * state as `navigator.onLine` and announces each change with a window `online`/`offline`
 * event; this turns that into React state.
 *
 * <p>`navigator.onLine === false` is reliable (no network interface / the browser is set
 * offline); `true` only means "some network", not "the backend answers" — which is why this is
 * an indication only and nothing gates a save on it.
 *
 * <p>The value is re-read when the listeners are attached, because an event fired between the
 * first render and the effect would otherwise be lost and the state stuck. The listeners are
 * removed on unmount, so leaving the module leaves nothing behind on `window`.
 */
var useOnlineStatus = function () {
    var _a = useState(readOnLine), online = _a[0], setOnline = _a[1];
    useEffect(function () {
        var update = function () { return setOnline(readOnLine()); };
        window.addEventListener('online', update);
        window.addEventListener('offline', update);
        update();
        return function () {
            window.removeEventListener('online', update);
            window.removeEventListener('offline', update);
        };
    }, []);
    return online;
};
export default useOnlineStatus;
